<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    海山站<br>
站点介绍<br>
海山站位于深圳市盐田区政府附近，车站沿深盐路东北-西南方向布置。东接盐田港西站，西接沙头角站。 车站色彩以竹林作为整体设计元素，以竹林体现曲径通幽的设计思路，重点区域用一体化设计打造“树荫”的设计。 车站为地下两层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有4个出入口，临近盐田区政府、盐田图书馆、盐田区政府公交站，车站周边有住宅小区及商场、生活超市等配套。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	23:18	8号线	5分10秒	5分45秒<br>
盐田路	06:44	00:23	8号线	5分10秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:17	8号线	4分钟	5分钟<br>
盐田路	06:44	00:23	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	00:07	8号线	4分钟	5分钟<br>
盐田路	06:44	01:23	8号线	4分钟	5分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
深盐路南侧(西)、鹏湾社区工作站、盐田区妇幼保健院、盐田产业服务中心、田东中学、东和社区服务站、工青妇活动中心、盐田中央公园<br><br>
A2出入口:<br>
深盐路北侧(西)、盐田区政府、盐田图书馆、盐田区医院、梧桐社区工作站、盐田区人民医院<br><br>
B出入口:<br>
深盐路南侧(东)、盐田区外国语小学、海滨栈道、盐田税务局<br><br>
C出入口:<br>
深盐路北侧(东)、海山街道办、海山公园、田东小学、盐田汽车站、田东社区工作站<br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 盐田区政府(B站台)<br>
85、205、30、358、38、M199、B924、E26、M191、M314、M362、M437、M444、M520、N21、NE26、高峰专线5、高峰专线58<br><br>
A2出入口:<br>
公交站名： 盐田区政府(A站台)<br>
E26、M191、M199、M314、M362、M437、M444、85、205、308、358、387、M520、N21、高峰专线58、B924<br><br>
B出入口:<br>
公交站名： 壹海城(A站台)<br>
B902社区微巴、B961、高峰专线182<br><br>
B出入口:<br>
公交站名： 壹海城(B站台)<br>
B961<br><br>
C出入口:<br>
公交站名： 盐田区政府东(B站台)<br>
68、B902社区微巴、B924、高峰专线182<br><br>
C出入口:<br>
公交站名： 盐田区政府东(A站台)<br>
68、B924、B982<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>